import React from "react";
import "./PrivacyPolicy.css";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-page">
      <div className="privacy-glow"></div>

      <div className="privacy-container">
        <h1 className="privacy-title">Privacy Policy</h1>

        <p className="privacy-intro">
          At Poonji Mitra, we take your privacy seriously. This Privacy Policy
          explains what personal information we collect and how we use it.
        </p>

        <section className="policy-section">
          <h2>1. Information We Collect</h2>
          <p>We may collect:</p>
          <ul>
            <li>
              <strong>Personal Information:</strong> Name, PAN, email, mobile
              number, KYC details, bank account details.
            </li>
            <li>
              <strong>Usage Data:</strong> Device type, IP address, app usage
              patterns.
            </li>
            <li>
              <strong>Transaction Data:</strong> Investment transactions,
              portfolio details.
            </li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>2. How We Use Your Information</h2>
          <p>We use your data to:</p>
          <ul>
            <li>Process investment transactions.</li>
            <li>Maintain compliance with SEBI and AMFI requirements.</li>
            <li>Provide customer support and personalized services.</li>
            <li>Improve app functionality and security.</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>3. Sharing of Information</h2>
          <p>We may share your data with:</p>
          <ul>
            <li>
              Mutual fund companies, registrar & transfer agents, and payment
              gateway providers.
            </li>
            <li>
              Regulatory bodies such as SEBI, AMFI, or other government
              authorities as required.
            </li>
            <li>
              Third-party service providers assisting in operations (bound by
              confidentiality agreements).
            </li>
          </ul>
          <p className="policy-note">
            We do not sell your personal data to third parties.
          </p>
        </section>

        <section className="policy-section">
          <h2>4. Data Storage & Security</h2>
          <ul>
            <li>
              Your personal data is stored securely using industry-standard
              encryption.
            </li>
            <li>
              We retain your information as long as necessary for legal,
              regulatory, and operational purposes.
            </li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>5. Your Rights</h2>
          <ul>
            <li>Access your personal data.</li>
            <li>Request corrections or updates.</li>
            <li>
              Request deletion of your account (subject to regulatory retention
              requirements).
            </li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>6. Cookies & Tracking</h2>
          <p>
            We may use cookies and analytics tools to enhance app performance
            and user experience.
          </p>
        </section>

        <section className="policy-section">
          <h2>7. Changes to Policy</h2>
          <p>
            We may update this Privacy Policy periodically. Any changes will be
            reflected in the app and communicated where necessary.
          </p>
        </section>

        <section className="policy-section delete-section">
          <h2>Delete Account & Data Removal Policy</h2>

          <h3>1. How to Request Account Deletion</h3>
          <ul>
            <li>
              Send an email to <strong>support@poonjimitra.com</strong> from
              your registered email address.
            </li>
            <li>Mention “Delete My Account” in the subject line.</li>
            <li>Provide your registered mobile number for verification.</li>
          </ul>

          <h3>2. What Happens After Deletion Request</h3>
          <ul>
            <li>Identity verification within 7 working days.</li>
            <li>Your account will be permanently deactivated.</li>
            <li>
              Personal details will be erased except where retention is required
              by SEBI/AMFI or other regulators (generally up to 8 years).
            </li>
          </ul>

          <h3>3. Non-Deletable Information</h3>
          <p>
            Certain transaction and KYC details must be retained for audit and
            compliance purposes under Indian financial regulations.
          </p>

          <h3>4. Post-Deletion Access</h3>
          <p>
            After deletion, you will lose access to all services, transaction
            history, and investment portfolio through the Poonji Mitra app.
          </p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
